import React from 'react';

import '../styles/components.css';

export const LoadingDots = () => (
  <div className="spinner">
    <div className="bounce1" />
    <div className="bounce2" />
    <div className="bounce3" />
  </div>
);
